import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e2cb2804 = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _616f3967 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _37bfda1a = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _635634fc = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _08c0bb5e = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _51a1e41c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5e290f8a = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _70ca468d = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _b1e5e6d2 = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _e2cb2804,
    name: "countries"
  }, {
    path: "/help",
    component: _616f3967,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _37bfda1a,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _635634fc,
    name: "redirect"
  }, {
    path: "/terms",
    component: _08c0bb5e,
    name: "terms"
  }, {
    path: "/",
    component: _51a1e41c,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _5e290f8a,
    children: [{
      path: "",
      component: _70ca468d,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _b1e5e6d2,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
